import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Automation from './components/Automation';
import CaseStudy from './components/CaseStudy';
import About from './components/About';
import FoundingOffer from './components/FoundingOffer';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Features />
        <Automation />
        <CaseStudy />
        <About />
        <FoundingOffer />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
